// TODO: Maybe let's rename this library from 'icon-picker' to 'ui-picker'
export * from './lib/color-picker/color-picker.component';
export * from './lib/icon-picker.component';
export * from './lib/icon-picker.service';
